import { Box, Grid, styled, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'

const Wrapper = styled(Box)`
  padding: 0 165px;
  margin-top: 60px;
  padding-bottom: 150px;
  @media (max-width: 1200px) {
    padding: 0 24px;
    margin-top: 60px;
    padding-bottom: 150px;
  }
  @media (max-width: 900px) {
    .MuiGrid-root {
      display: block;
      width: 100%;
      max-width: 100%;
      margin-left: 0 !important;
    }
    .MuiGrid-item {
      padding-left: 0 !important;
    }
    padding: 0 16px 100px 16px;
    > p {
      font-size: 32px;
    }
  }
`

const TitleTypography = styled(Typography)`
  font-style: normal;
  font-weight: 700;
  font-size: 56px;
  line-height: 72px;
  font-family: 'Roboto Condensed', sans-serif;
  color: ${props => props.theme.colors.white};
  margin-bottom: 20px;
  @media (max-width: 1200px) {
    font-size: 56px;
    line-height: 72px;
    font-family: 'Roboto Condensed', sans-serif;
    color: ${props => props.theme.colors.white};
    margin-bottom: 20px;
  }
`
const FAQBox = styled(Box)`
  font-weight: 500;
  font-size: 28px;
  line-height: 32px;
  color: ${props => props.theme.colors.white};
  background: #161616;
  padding: 32px;
  height: 200px;
  cursor: pointer;
  transition: all 200ms;
  :hover {
    background: ${props => props.theme.colors.white};
    color: ${props => props.theme.colors.black};
  }

  @media (max-width: 900px) {
    width: 100%;
    height: 108px;
    height: unset;
    font-size: 22px;
    .MuiGrid-item {
      padding-left: 0;
    }
  }
`
export function FAQ() {
  const navigate = useNavigate()
  return (
    <Wrapper>
      <TitleTypography>About</TitleTypography>
      <Grid container spacing="10px">
        <Grid item xs={4}>
          <FAQBox onClick={() => navigate('protocol/YeehaGames')}>Welcome to Yeeha Games</FAQBox>
        </Grid>
        <Grid item xs={4}>
          <FAQBox onClick={() => navigate('protocol/NFT')}>What are GameFi and NFTs?</FAQBox>
        </Grid>
        <Grid item xs={4}>
          <FAQBox onClick={() => navigate('protocol/Mission')}>Mission</FAQBox>
        </Grid>
      </Grid>
    </Wrapper>
  )
}
